import { z } from 'my-zod'
import { makeValidator } from '../../internal/validator'
import { announcementModel } from './announcement-model'

export const announcementUpdate = announcementModel.omit({
  shortId: true,
  creatorProfileId: true,
  lifecycleStatus: true,
  createdDate: true,
  lastModifiedDate: true,
  startDate: true,
  endDate: true,
  sentDate: true,
  removedDate: true,
  deletedDate: true
})

export type announcementUpdate = z.infer<typeof announcementUpdate>

export const validateAnnouncement = makeValidator<announcementUpdate>((announcement, error) => {
  const audiences = [announcement.outfitterIds, announcement.regions, announcement.productLines, announcement.roles].filter(
    (entries) => entries.length
  )
  if (audiences.length > 1) {
    error('Cannot have multiple audiences for an announcement', ['outfitterIds'])
  }
})
